import React from "react";
import { Link } from "react-router-dom";
import "../../styles/other.css";


const posts = [
  {
    id: 2,
    image: "https://wallpaperaccess.com/full/5368940.jpg",
    title: "THE BEST ARTICLES ON LIFE PHILOSOPHY.",
    date: "April 12, 2026",
    link: "https://www.scotthyoung.com/blog/the-best-articles-on-life-philosophy/",
  },
  {
    id: 1,
    image: "https://imgs.search.brave.com/8yX9jv3ZK3uS11Isq37sjffOJEKevNXgtgNddsCvKPU/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pbWFn/ZXMudW5zcGxhc2gu/Y29tL3Bob3RvLTE2/Mzk3MDUxMjM3NzIt/MTRiZjVjNDU5MjVi/P2ZtPWpwZyZxPTYw/Jnc9MzAwMCZhdXRv/PWZvcm1hdCZmaXQ9/Y3JvcCZpeGxpYj1y/Yi00LjEuMCZpeGlk/PU0zd3hNakEzZkRC/OE1IeHpaV0Z5WTJo/OE1qQjhmRzFoYmlV/eU1ISmxZV1JwYm1j/bE1qQmliMjlyZkdW/dWZEQjhmREI4Zkh3/dw",
    title: "AN INTRIEST BOOK THAT I READ RECENTLY.",
    date: "April 4, 2026",
    link: "https://www.goodreads.com/en/book/show/1617.Night",
  },
];

function Other() {
  return (
    <aside className="other">
      <div className="other-header">
        <h2 className="other-title">Fresh Thoughts</h2>
      </div>
      <div className="horizontal-line-other" />

      <div className="other-list">
        {posts.map((post) => (
          <article className="other-card" key={post.id}>
            <Link to={post.link} className="other-image-link">
              <img src={post.image} alt={post.title} className="other-image" />
            </Link>

            <div className="other-content">
              <p className="other-card-title">
                <Link to={post.link} className="other-title-link">
                  {post.title}
                </Link>
              </p>

              <a
                href={post.link}
                className="other-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Read more →
              </a>

              <p className="other-date">{post.date}</p>

            </div>
          </article>
        ))}
      </div>
    </aside>
  );
}

export default Other;